export default __webpack_public_path__ + "static/media/Tyler-TradFitoDeFi.abbb5d23.jpg";